// extracted by mini-css-extract-plugin
module.exports = {"asset-addresses":"AddressesTab-asset-addresses--XV-WD","auto-width":"AddressesTab-auto-width--30XCh"};